function init_initvideo(){
    try{
        if(typeof Hls!="undefined" &&  Hls.isSupported()) {
            var howlerSet=_mySound.takeMuteObj();
            var hideStr="#mainButtonsBar,#mainEmailConf,#mainErrorReporting";
            $(hideStr).addClass("hide");
            Howler.mute(true);
            _moduleEvents.on("moduleClear",function(){
                $(hideStr).removeClass("hide");
                Howler.mute(false);
            });



            var video = document.getElementById('videoMain');
            var hls = new Hls();
            hls.startLevel=-1;
            hls.attachMedia(video);
            hls.on(Hls.Events.ERROR, function (event, data) {
                if (data.fatal) {
                    switch(data.type) {
                    case Hls.ErrorTypes.NETWORK_ERROR:
                        hls.startLoad();
                        break;
                    case Hls.ErrorTypes.MEDIA_ERROR:
                        hls.recoverMediaError();
                        break;
                    default:
                        hls.destroy();
                        $.goToLocation("map");
                        break;
                    }
                }
            }).on(Hls.Events.MEDIA_ATTACHED, function () {
                hls.loadSource($.getVideoPath("intro"));
                hls.on(Hls.Events.MANIFEST_PARSED,function() {
                    video.play();
                });
                //myPopupClosed
                $(video).off("ended").on("ended",function(){
                    $.goToLocation("map");
                });
            });

            if(howlerSet.sound==1){
                video.muted=true;
            }
            else{
                video.muted=false;
            }
            _moduleEvents.on("howlerMute",function(hObj){
                if(hObj.sound==1){
                    video.muted=true;
                }
                else{
                    video.muted=false;
                }

            });

        }
        else{
             _semaphoreXHR.tryClear();
            $.goToLocation("map");
        }
    }
    catch(e){
        _semaphoreXHR.tryClear();
        $.goToLocation("map");
    }
}